import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import ReportList from "../../../common/ReportList";
import Constants from "../../../../common/Constants";
// import moment from "moment";
// import { formatDateTime } from "../../../../common/Validations";
import PrintStatusReports from "./PrintStatusReports";
import ChemicalPopover from "../master/ChemicalPopover";
import { formatDateTime } from "../../../../common/Validations";

const ChemicalBatchReports = () => {
  const { t } = useTranslation();
  const [displayFilter, setDisplayFilter] = useState(false);
  const [selectedRows, setSelectedRows] = useState(false);
  const [openViewJobcardCode, setOpenViewJobcardCode] = useState(false);

  // Popover state: open, position, chemicals
  const [popover, setPopover] = useState({
    open: false,
    x: 0,
    y: 0,
    chemicals: [],
  });

  // Handle click on "Chemical List"
  const handleChemicalListClick = (event, row) => {
    event.stopPropagation();
    setPopover({
      open: true,
      x: event.clientX,
      y: event.clientY,
      chemicals: row.values,
    });
  };

  // Close popover
  const handlePopoverClose = () => {
    setPopover((p) => ({ ...p, open: false }));
  };

  const columnsData = [
    {
      name: "Batch No",
      selector: (row) => row.chemicalBatchNo,
      sortable: true,
      width: "140px",
      cell: (row) => (
        <>
          <span className="bg-table-status bg-table-new-status">
            {row.chemicalBatchNo}
          </span>
        </>
      ),
    },
    {
      name: t("msg_reports.msg_jobstatus_report.col_jobcard"),
      selector: (row) => row.jobcard,
      sortable: true,
      width: "165px",
      cell: (row) => (
        <>
          <span className="bg-table-status bg-table-new-status">
            {row.jobcard}
          </span>
        </>
      ),
    },

    {
      name: "Chemicals Value",
      width: "150px",
      cell: (row) => (
        <span
          style={{
            cursor: "pointer",
            color: "#1442b7",
            fontWeight: 600,
            display: "flex",
            alignItems: "center",
          }}
          onClick={(e) => handleChemicalListClick(e, row)}
        >
          <i class="bi bi-flask"></i> &nbsp; Chemical List
        </span>
      ),
      sortable: false,
    },
    {
      name: "User",
      selector: (row) => row.loginUserId,
      sortable: true,
      width: "160px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row.loginUserId} </p>
          <p className="m-0 p-0 ">{row.loginUserName} </p>
        </div>
      ),
    },
    {
      name: "Created At",
      selector: (row) => row.dbDateTimeCreated,
      sortable: true,
      width: "160px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{formatDateTime(row.dbDateTimeCreated)}</p>
        </div>
      ),
    },
    {
      name: "Department",
      selector: (row) => row.deptName,
      sortable: true,
      width: "250px",
      cell: (row) => (
        <>
          {row.deptName ? (
            <span className="bg-table-status bg-table-first-status">
              {row.deptName}
            </span>
          ) : (
            ""
          )}
        </>
      ),
    },
    {
      name: t("msg_reports.msg_production_status.size"),
      selector: (row) => row.sizeCode,
      sortable: true,
      width: "200px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row.sizeCode} </p>
          <p className="m-0 p-0 ">{row.sizeName} </p>
        </div>
      ),
    },
    {
      name: t("msg_reports.msg_jobstatus_report.col_priority"),
      selector: (row) => row.priority,
      sortable: true,
      width: "160px",
      cell: (row) => (
        <>
          {row.priority === "urgent" ? (
            <span className="bg-table-status bg-table-danger-status">
              {t("msg_overview.urgent")}
            </span>
          ) : row.priority === "regular" ? (
            <span className="bg-table-status bg-table-info-status">
              <strong>{t("msg_overview.regular")}</strong>
            </span>
          ) : (
            <>{row.priority}</>
          )}
        </>
      ),
    },
    {
      name: t("msg_reports.msg_jobstatus_report.col_customer"),
      selector: (row) => row.customerName,
      sortable: true,
      width: "200px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.customerName}</p>
        </div>
      ),
    },
    {
      name: t("msg_reports.msg_jobstatus_report.col_quantity"),
      selector: (row) => row.quantityPerJobCard,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <>
          <span className="bg-table-status bg-table-text-status">
            {row.originalQuantityPerJobCard} / {row.quantityPerJobCard}
          </span>
        </>
      ),
    },
  ];

  const handleSelectedRowsChange = ({ selectedRows }) => {
    setSelectedRows(selectedRows);
  };
  // eslint-disable-next-line no-unused-vars
  const handlePrintClick = () => {
    if (selectedRows) {
      setOpenViewJobcardCode(true);
    }
  };
  const resetJobcardModal = () => {
    setOpenViewJobcardCode(false);
  };
  return (
    <main className="generatejobcard main" id="main">
      <Row className="justify-center subContent">
        <Col xs={8} md={8} className="rightSide">
          <div className="rightSideInner timesheet">
            <h2 className="mainTitle">
              {t(
                "msg_reports.msg_chemicalbatch_report.chemicalbatch_report_title"
              )}
            </h2>
            <p className="subText">
              {t("msg_reports.msg_chemicalbatch_report.details_page")}
            </p>
          </div>
        </Col>
        <Col xs={4} md={4} className="leftSide">
          <Button
            type="button"
            variant="primary"
            size="lg"
            className="btn btn-primary float-right searchFilter-btn"
            onClick={() => setDisplayFilter(!displayFilter)}
          >
            <i class="bi bi-filter"> </i>
          </Button>
        </Col>
        <hr />
      </Row>
      {/* <div className="jobcard-div">
        <Button variant="primary" onClick={handlePrintClick}>
          {"PRINT"}
        </Button>{" "}
        <span> </span>
      </div> */}
      <div>
        <ReportList
          selectableRows={false}
          columnsData={columnsData}
          displayProdStatusFilter={displayFilter}
          handleSelections={handleSelectedRowsChange}
          //rowsData={rowsData}
          resetFilerBox={setDisplayFilter}
          pageName={t(
            "msg_reports.msg_chemicalbatch_report.chemicalbatch_report_code"
          )}
          pageURL={Constants.REPORTS.CHEMICALBATCHREPORTS.list}
          name={Constants.REPORTS.CHEMICALBATCHREPORTS.name}
        />
      </div>

      {openViewJobcardCode && (
        <PrintStatusReports
          selectedItems={selectedRows}
          show={openViewJobcardCode}
          onHide={() => {
            resetJobcardModal();
          }}
        ></PrintStatusReports>
      )}

      <ChemicalPopover
        open={popover.open}
        x={popover.x}
        y={popover.y}
        chemicals={popover.chemicals}
        onClose={handlePopoverClose}
      />
    </main>
  );
};

export default ChemicalBatchReports;
